import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { importSourceIconBgMap } from "./constants";
import type { ImportSourceType } from "./types";

export const Truncate = styled.div`
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    max-width: 100%;
`;

export const ImportSourceContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 8px;
    border: 1px solid ${colorsPalettes.carbon[50]};
    width: fit-content;
    min-width: 0;
    max-width: 220px;
    border-radius: 8px;
    position: relative;
`;

export const StyledImportSourceIcon = styled.div<{ type: ImportSourceType; hasError?: boolean }>`
    background-color: ${({ type, hasError }) => (hasError ? colorsPalettes.red[400] : importSourceIconBgMap[type])};
    border-radius: 8px;
    padding: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
    flex-shrink: 0;
`;

export const CloseButton = styled.button`
    background: transparent;
    border: none;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    top: -12px;
    right: -12px;
    padding: 0;
`;

export const TextWrapper = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    display: contents;
`;

export const ImportSourceTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
    flex: 1;
`;

export const LocationsBadge = styled.div`
    position: absolute;
    top: 0;
    left: 32px;
    width: 16px;
    height: 16px;
    border-radius: 10px;
    background: ${colorsPalettes.carbon[50]};
    border: 2px solid ${colorsPalettes.carbon[0]};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    cursor: help;
`;
